import React, { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

const Pagination = ( { pages, page, setPage, entity, setLimitPage}) => {
      const [editMode, setEditMode] = useState(false);
      const [tempPage, setTempPage] = useState(page);
    
      const handleInputChange = (e) => {
        setTempPage(e.target.value);
      };
    
      const handleBlurOrEnter = (e) => {
        if (e.type === 'blur' || e.key === 'Enter') {
          let newPage = parseInt(tempPage);
          if (!isNaN(newPage) && newPage >= 1 && newPage <= pages) {
            setPage(newPage);
          }
          setEditMode(false);
        } else if (e.key === 'Escape') {
          setEditMode(false);
        }
      };
    
      return (
        // 
        <div className="row d-flex justify-content-around align-items-center mt-1">
          <div className="col-md-3 d-inline-flex align-items-center">
            <strong className="mr-2">Mostrar:</strong>
            <select name="" id="" className="w-20 form-control form-control-sm" onChange={(e)=> setLimitPage(e.target.value)}>
              {CONFIGURACIONES.TABLES.PAGES.map((el, index) => (
                <option key={`${index}_${entity}`} value={el}>{el}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3 d-inline-flex align-items-center">
            <div>
              <strong className="mr-2">Página </strong>
              {editMode ? (
                <input
                  type="text"
                  inputMode='numeric'
                  className="form-control form-control-sm d-inline-block"
                  style={{ width: '60px' }}
                  value={tempPage}
                  onChange={handleInputChange}
                  onBlur={handleBlurOrEnter}
                  onKeyDown={handleBlurOrEnter}
                  autoFocus
                  key={`current_${entity}`}
                />
              ) : (
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setTempPage(page);
                    setEditMode(true);
                  }}
                >
                  {page}
                </span>
              )}
              <span> <strong>de</strong> {pages}</span>
            </div>
            
            <div className="btn-group" role="group">
              <button
                key={`prev_${entity}`}
                type="button"
                className="btn btn-light btn-sm"
                disabled={page === 1}
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              <button
                type="button"
                key={`next_${entity}`}
                className="btn btn-light btn-sm"
                disabled={page === pages}
                onClick={() => setPage((prev) => Math.min(prev + 1, pages))}
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>        
        </div>
      );
};


export default Pagination